// ТЕМПЕРАТУРА ПАЛИТРЫ — какой набор цветов стоит на экране прямо сейчас (`s903.d1`, слово
// Кирилла 23.09; зеркало решения — `docs/design/WIZARD-CANON.md`, раздел «Температура палитры»).
//
// Значения тёплого набора живут в css (`src/styles/wizard-palette-warm.css`), здесь — ТОЛЬКО
// правило «когда он включён». Разделение не косметическое: правило проверяется без браузера и
// без экрана, а значения сверяются с байтом борда, и это две разные приёмки.
//
// ⭐ АТРИБУТ — ФУНКЦИЯ ОТРИСОВАННОГО ЭКРАНА (view), А НЕ `session.step`. Разница видна ровно в
// состоянии входа (`s895.d1`): конверт помнит шаг остановки — скажем, `s4/2/b`, — а на экране
// стоит лендинг. Читай мы `session.step`, лендинг покрасился бы тёплым, потому что человек когда-то
// дошёл до четвёртого шага. Провайдер уже сводит пару (`entry`, конверт) в одно поле `view` —
// отсюда и читаем.
//
// ⭐ ПОЧЕМУ СНЯТИЕ ВАЖНЕЕ УСТАНОВКИ. Паспорт (`r10.css`) читает ПЯТЬ из восьми имён раскола
// (`--paper-faint`, `--ink-600`, `--ink-900`, `--ink-850`, `--ink-550`), то есть забытый на
// `documentElement` атрибут двинул бы byte-parity §II/§III — молча, без единого красного теста в
// jsdom. Сегодня не стреляет: маршруты разные, и касаний `documentElement` в `src/` больше нет
// нигде. Поэтому снятие — не «уборка», а само правило, и проверяется оно отдельным утверждением.

import { stepNumber } from './address.js';

/** Атрибут-переключатель. Имя — из решения, менять нельзя: на него смотрит css. */
export const PALETTE_ATTR = 'data-palette';

/** Значение тёплого набора. */
export const WARM = 'warm';

/**
 * Шаги тёплой половины — ПЕРЕЧНЕМ, а не предикатом (`s903.d1` снял признак «есть ли поле ввода»:
 * он ломается ровно на шаге 3, где есть и textarea, и ползунки, и чипы).
 */
export const WARM_STEPS = [3, 4, 5];

/**
 * Какой набор палитры нужен экрану по его адресу.
 *
 * @param {string} view адрес ОТРИСОВАННОГО экрана (`view` провайдера), а не `session.step`
 * @returns {'warm'|null} `null` = холодный набор, то есть атрибута на корне нет вовсе
 */
export function paletteFor(view) {
  return WARM_STEPS.includes(stepNumber(view)) ? WARM : null;
}

/**
 * Поставить или снять атрибут на корне документа.
 *
 * Холодный набор выражается ОТСУТСТВИЕМ атрибута, а не значением `cold`: холодная лесенка — это
 * базовый `:root` в `wizard-tokens.css`, и второе имя для «ничего не перекрываем» завело бы
 * состояние, которого в css нет.
 *
 * Возвращает поставленное значение (или `null`) — чтобы вызывающему было что проверить, не
 * читая DOM второй раз.
 *
 * @param {Element|null} root обычно `document.documentElement`
 * @param {string} view адрес отрисованного экрана
 */
export function applyPalette(root, view) {
  const value = paletteFor(view);
  if (!root || typeof root.setAttribute !== 'function') return value;
  if (value) root.setAttribute(PALETTE_ATTR, value);
  else root.removeAttribute(PALETTE_ATTR);
  return value;
}

/**
 * Снять атрибут безусловно. Нужен на размонтировании визарда: документ может пережить оболочку
 * (дев-маршрут паспорта в той же вкладке), и тёплая лесенка осталась бы на нём висеть.
 */
export function clearPalette(root) {
  if (root && typeof root.removeAttribute === 'function') root.removeAttribute(PALETTE_ATTR);
}
